
import {NavLink} from 'react-router-dom';
import classes from './DoctorsStyle.module.css';

const Header = (props) => {
    return (
        <div className={classes.main_body}>
            <div className={classes.heading}>
                <NavLink to="/doctors"
                         className={props.activeLink === 'doctors' ? classes.active : null}
                         onClick={() => props.HeaderItem('doctors')}
                >Online Doctors</NavLink>
            </div>
        </div>
    )
}
export default Header;
